import {SSAI_RELATED_SAMPLE_MARKER} from '../core/ssai/ssaiUtils';
import type {Sample} from '../types/Sample';

import {isValidString} from './stringUtils';
import {removeTrailingSlash} from './Utils';
import {getWindowLocationPathname} from './windowUtils';

/**
 * Clear all "state" values from the sample (all values that describe "playing sample", "startup sample" ...).
 */
export function clearSampleStateValues(sample: Sample): void {
  sample.ad = 0;
  sample.adId = undefined;
  sample.adIndex = undefined;
  sample.adPosition = undefined;
  sample.adSystem = undefined;
  sample.autoplay = undefined;
  sample.buffered = 0;
  sample.castTech = undefined;
  sample.completed = undefined;
  sample.drmLoadTime = undefined;
  sample.droppedFrames = 0;
  sample.duration = 0;
  sample.errorCode = undefined;
  sample.errorData = undefined;
  sample.errorMessage = undefined;
  sample.errorSegments = undefined;
  sample.errorSeverity = undefined;
  sample.isProgramChange = undefined;
  sample.pageLoadTime = 0;
  sample.paused = 0;
  sample.played = 0;
  sample.playerStartupTime = 0;
  sample.seeked = 0;
  sample.startupTime = 0;
  sample.state = undefined;
  sample.videoStartFailed = undefined;
  sample.videoStartFailedReason = undefined;
  sample.videoStartupTime = 0;

  sample[SSAI_RELATED_SAMPLE_MARKER] = undefined;
}

export function getDefaultSamplePath(): string | undefined {
  const pathname = getWindowLocationPathname();
  return isValidString(pathname) ? removeTrailingSlash(pathname) : undefined;
}
